import { render } from "./BillingFindSuppliersPage.vue?vue&type=template&id=1bb6439f&ts=true"
import script from "./BillingFindSuppliersPage.vue?vue&type=script&lang=ts"
export * from "./BillingFindSuppliersPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__